export default __webpack_public_path__ + "static/media/sugarss.c2d0ab62.svg";